<button mat-icon-button class="actions-buttons" *ngIf="showActionsForSelectedZCVersion"
    [disabled]="isDeleting || isOrphan">
    <mat-icon matTooltip="Modify Calculation Results" (click)="openLastUpdatedSelectionDialog($event)"
        class="actions-mat-icons">today</mat-icon>
</button>